import ComicBox from 'component/ComicBox'
import { Wrapper } from './Styled'
import { memo } from 'react'

interface Template206Props {
  videoData?: any[]
}

// 豎版兩個半向左滑動
function Template206({ videoData }: Template206Props) {
  return (
    // 因這裡有滑動事件, 設定.swiper-no-swiping 禁止CMS View的左右滑動切換頻道功能
    <Wrapper className={'swiper-no-swiping'}>
      {videoData?.map((item, i) => {
        return <ComicBox overflow={true} key={i} comicInfo={item} columns={2.5} allowUnload />
      })}
    </Wrapper>
  )
}

export default memo(Template206)
